export const EndedChip = (): JSX.Element => (
  <div className="flex w-fit items-center rounded-full bg-red/10 px-3 py-1 text-center text-sm text-red">
    Ended
  </div>
);
